export default __webpack_public_path__ + "static/media/pin-light-blue.c0942188.svg";